import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import UnloadingTemplate from '../../../pages/unloadings/unloadingTemplate/unloadingTemplate';
import SectionContent from '../../../components/sectionContent/sectionContent';
import Sidebar from '../../../components/sidebar/Sidebar';

import '../../../scss/App.scss';
import { IUserOptions } from '../../../types/interfaces';

const AdminUnloadingTemplateSection: FC = () => {
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent section='Загрузка шаблонов' pageName='unloadings'>
				<div className='content__main'>
					<div className='btns'>

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:excel')) && <Link to='/unloadings/excel' className='tab'>
							<div className='buttons__btn'>Excel</div>
						</Link>}

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:zip')) && <Link to='/unloadings/zip' className='tab'>
							<div className='buttons__btn'>Zip</div>
						</Link>}

						{claims && claims?.length > 0 && (claims.includes('admin') || claims.includes('orders:payrolls')) && <Link to='/unloadings/tables' className='tab'>
							<div className='buttons__btn'>Табели</div>
						</Link>}

						{(claims.includes('admin') || claims.includes('orders:cron')) && (
							<Link to='/unloadings/cron' className='tab'>
								<div className='buttons__btn'>Cron</div>
							</Link>
						)}

            <Link to='/unloadings/template' className='tab'>
								<div className='buttons__btn  --active'>Загрузка шаблонов</div>
						</Link>
					</div>
					<UnloadingTemplate />
				</div>
			</SectionContent>
		</div>
	);
};

export default AdminUnloadingTemplateSection;
